export default __webpack_public_path__ + "static/media/Dapazin-5-eng.f12d2585.jpg";